module.exports = __webpack_public_path__ + "static/img/banner-jinian.62f5086.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-jinian.jpg
// module id = WiY+
// module chunks = 0